import { LOGIN_SOURCES, } from '../../../types/paramsConfig.js';
import { sourceDataActions } from './sourceDataSlice.js';
import { safeInitSourceData } from './safeInitSourceData.js';
const referrerMapTable = [
    {
        pattern: 'candidate-login',
        loginSource: LOGIN_SOURCES.OTHER,
        redirectOverride: '/jobs/candidate-login-redirect',
    },
];
const buildFromReferrer = (referrerUrl) => {
    const found = referrerMapTable.find((item) => referrerUrl.match(item.pattern));
    if (found) {
        return {
            loginSource: found.loginSource,
            redirectionUrl: found.redirectOverride || referrerUrl,
        };
    }
    return {
        loginSource: LOGIN_SOURCES.OTHER,
        redirectionUrl: '/',
    };
};
export const initSourceDataByReferrer = (referrerUrl) => async (dispatch) => {
    const sourceData = buildFromReferrer(referrerUrl);
    try {
        dispatch(sourceDataActions.initSourceData(sourceData));
    }
    catch (error) {
        console.error('[initSourceDataByReferrer] Error: ', error);
    }
};
export const initSourceDataByCustomEvent = (payload) => async (dispatch) => {
    try {
        const { loginSource, disableCvUpload, redirectionUrl, onLoginSuccess: callbackFunction, isDismissible = true, showRecruiterContinueButton = false, disableModalSlideIn, skipReturningUser = false, } = payload || {};
        safeInitSourceData(dispatch, loginSource, redirectionUrl);
        disableCvUpload &&
            dispatch(sourceDataActions.updateRedirectAfterSuccessfulRegistration(disableCvUpload));
        callbackFunction &&
            dispatch(sourceDataActions.updateCallbackFunction(callbackFunction));
        disableModalSlideIn &&
            dispatch(sourceDataActions.updateDisableModalSlideIn(disableModalSlideIn));
        dispatch(sourceDataActions.updateIsDismissible(isDismissible));
        dispatch(sourceDataActions.updateSkipReturnUser(skipReturningUser));
        dispatch(sourceDataActions.updateShowRecruiterContinueButton(showRecruiterContinueButton));
    }
    catch (error) {
        console.error('Error:', error);
    }
};
//# sourceMappingURL=thunks.js.map